module.exports = __webpack_public_path__ + "img/unsupported_file_format.6a9e4b85.svg";